import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { AccountSummary } from '../models/debtor-summary.model';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class DebtorService {
  constructor(
    private appConfigService: AppConfigService,
    private http: HttpClient) {
  }

  public getAccountSummary(): Observable<AccountSummary> {
    return this.http.get<AccountSummary>(`${this.appConfigService.getConfig().apiUrl}debtor/account/summary`);
  }
}
